module.exports = __webpack_public_path__ + "static/media/loginback.d747df08.svg";